import React from 'react'
import './SectionFour.scss'

const SectionFour = () => {
  return (
    <div className='sectionFour'>
      <div className='sectionFourDiv'>
        <h2>Find Best Place For Living</h2>
          <p>
              Spend vacations in best hotels and resorts find the great place of your
             choice using different searching options.
          </p>
          <button>Contact us</button>
      </div>
    </div>
  )
}

export default SectionFour